<stb-modal
  [noPMargins]="true"
  [responsiveMode]="'normal'"
  [isShowing]="true"
  (cancelClick)="close()"
  (primaryClick)="refresh()"
  [primaryText]="'refreshModal.action' | fms"
  [header]="'refreshModal.title' | fms"
>
  <p>
    {{ "refreshModal.description" | fms }}
  </p>
</stb-modal>
